import { render, staticRenderFns } from "./auth-loader.vue?vue&type=template&id=1ef4ddc0&scoped=true"
import script from "./auth-loader.vue?vue&type=script&lang=js"
export * from "./auth-loader.vue?vue&type=script&lang=js"
import style0 from "./auth-loader.vue?vue&type=style&index=0&id=1ef4ddc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef4ddc0",
  null
  
)

export default component.exports